export class NavComponent {

  _mobileOpenMenuBtnEl = null;
  _mobileCloseMenuBtnEl = null;
  _menuEl = null;
  _isMobileMenuOpened = false;
  _nav = null;

  init() {
    this._mobileOpenMenuBtnEl = document.querySelector('.open-menu-btn');
    this._mobileCloseMenuBtnEl = document.querySelector('.close-menu-btn');

    if (this._mobileOpenMenuBtnEl && this._mobileCloseMenuBtnEl) {
      this.afterComponentRender();
    }
  }

  afterComponentRender() {
    this._menuEl = document.querySelector('.nav__inner__bottom');
    this._nav = document.querySelector('.nav');

    this.openMobileMenu();
    this.closeMobileMenu();
    this.onClickAnywhere();
    this.updateScrollPaddingTop();

    window.addEventListener('resize', this.updateScrollPaddingTop.bind(this));
  }

  openMobileMenu() {
    this._mobileOpenMenuBtnEl.addEventListener('click', () => {
      this._isMobileMenuOpened = true;
      this._menuEl.classList.add('active');
    });
  }

  closeMobileMenu() {
    this._mobileCloseMenuBtnEl.addEventListener('click', () => {
      this._isMobileMenuOpened = false;
      this._menuEl.classList.remove('active');
    });
  }

  onClickAnywhere() {
    window.addEventListener('click', e => {
      if (
        this._isMobileMenuOpened &&
        !e.target.closest('.nav__inner__bottom') &&
        !e.target.closest('.open-menu-btn')
      ) {
        this._mobileCloseMenuBtnEl.click();
      }
    });
  }

  updateScrollPaddingTop() {
    document.documentElement.style.scrollPaddingTop = this._nav.offsetHeight + 'px';
  }
}
